/* eslint-disable camelcase */

class Section implements MerchantosSectionsSection {
  name: string;

  constructor(name: string) {
    this.name = name;
  }

  open = () => {
    const content_map = {} as ContentMap;
    content_map.form_name = 'section.open';
    content_map.name = this.name;
    window.doServerCall(content_map, (result) => window.merchantos.sections.load(result));
    return true;
  };

  load = (result: TSFixMe) =>
    $(`#${this.name.replace('.', '_')}_section`)
      .htmlReplace(result.html)
      .find('.autofocus')
      .first()
      .trigger('select');
}

class Sections implements MerchantosSections {
  sections: { [key: string]: MerchantosSectionsSection };

  section: MerchantosSectionsSectionConstructor;

  constructor() {
    this.sections = {};
    this.section = Section;
  }

  getSection = (name: string) => {
    if (!this.sections[name]) {
      // eslint-disable-next-line new-cap
      this.sections[name] = new this.section(name);
    }
    return this.sections[name];
  };

  open = (name: string) => {
    const sections = this.getSection(name);
    sections.open();
  };

  load = (result: AjaxFormsResponse) => {
    if (!result.name || !result.html) return;
    const sections = this.getSection(result.name);
    sections.load(result);
  };
}

window.merchantos.sections = new Sections();
